import { useAppStore } from "@/store/app";
import cx from "classnames";
import { useEffect, useRef, useState, type ReactNode } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { MdClose } from "react-icons/md";
import { useDebouncedCallback } from "use-debounce";

function SearchBar() {
  const { searchKey, setSearchKey, isSearchOpen, setIsSearchOpen } =
    useAppStore();
  const inputRef = useRef<HTMLInputElement>(null);

  const [localSearchKey, setLocalSearchKey] = useState(searchKey);

  const updateSearchKey = useDebouncedCallback(() => {
    //console.debug("SearchBar debounced updateSearchKey", localSearchKey);
    setSearchKey(localSearchKey);
  }, 200);

  useEffect(() => {
    updateSearchKey.callback();
  }, [localSearchKey, updateSearchKey]);

  useEffect(() => {
    if (isSearchOpen) {
      inputRef.current?.focus();
    }
  }, [isSearchOpen]);

  const iconButton = () => {
    let iconButton: ReactNode | null = (
      <div
        className="btn btn-ghost btn-circle text-accent-content text-2xl"
        onClick={() => {
          window.analyticsLogEvent("Clicked Search Icon");
          setIsSearchOpen(true);
        }}
      >
        <AiOutlineSearch />
      </div>
    );
    if (isSearchOpen && localSearchKey === "") {
      iconButton = null;
    } else if (isSearchOpen) {
      iconButton = (
        <div
          className="btn btn-ghost btn-circle text-accent-content text-2xl"
          onClick={() => {
            setLocalSearchKey("");
            inputRef.current?.focus();
          }}
        >
          <MdClose />
        </div>
      );
    } else {
      iconButton = (
        <div
          className="btn btn-ghost btn-circle text-accent-content text-2xl"
          onClick={() => {
            window.analyticsLogEvent("Clicked Search Icon");
            setIsSearchOpen(true);
          }}
        >
          <AiOutlineSearch />
        </div>
      );
    }
    return iconButton;
  };

  return (
    <form
      className={cx("flex", isSearchOpen && "w-full")}
      noValidate
      autoComplete="off"
      spellCheck="false"
      onSubmit={() => false}
    >
      <input
        id="song-search-input"
        placeholder="Search…"
        ref={inputRef}
        disabled={!isSearchOpen}
        className={cx(
          "bg-transparent outline-none text-accent-content text-xl",
          isSearchOpen ? "w-full" : "w-0",
        )}
        value={localSearchKey}
        onChange={(e) => setLocalSearchKey(e.target.value)}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
        }}
      />
      {iconButton()}
    </form>
  );
}

export default SearchBar;
